import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Taiko/LoginStatic'
import CService from './views/Taiko/CService'
import Guide from './views/Taiko/Guide'
import Songs from './views/Taiko/Songs'
import Store from './views/Taiko/Store'
import WorldChampionship from './views/Taiko/WorldChampionship'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta:{
        title:'登入二维码'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: CService,
      meta:{
        title:'客服二维码'
      }
    },
    {
      path: '/guide',
      name: 'guide',
      component: Guide,
      meta:{
        title:'游戏介绍'
      }
    },
    {
      path: '/songs',
      name: 'songs',
      component: Songs,
      meta:{
        title:'歌曲列表'
      }
    },
    {
      path: '/store',
      name: 'store',
      component: Store,
      meta:{
        title:'店铺分布'
      }
    },
    {
      path: '/championship',
      name: 'championship',
      component: WorldChampionship,
      meta:{
        title:'世界冠军赛'
      }
    },
  ]
})
